import * as _ from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import {
  Accordion,
  AccordionContext,
  Card,
  Col,
  Row,
  Tab,
  Tabs,
  useAccordionToggle,
} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import { useTranslation } from 'react-i18next'
// MUI import
import FilterListIcon from '@mui/icons-material/FilterList'
import { Box, Button, IconButton, Stack, Typography } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import dayjs from 'dayjs'
// Project imports
import emptyKnowledge from '@/assets/New-images/empty-knowledge.svg'
import {
  KNOWLEDGE_ARCHIVED,
  KNOWLEDGE_KNOWLEDGE_CREATE_FROM_SCRATCH,
  REVIEW_QUIZ_QUESTIONS,
  TOOLKIT_GENERATE_QNA_UPLOAD_DOC,
} from '@/config'
import '@/routes/Knowledge/AllKnowledge/AllKnowledge.scss'
import KnowledgeCreateFromScratch from '@/routes/Knowledge/KnowledgeCreateFromScratch/KnowledgeCreateFromScratch'
import UploadedDocuments from '@/routes/UploadedDocuments/UploadedDocuments'
import { getCommonState, getIsSuperAdmin } from '@/store/common/selector'
import {
  bulkAssignModules,
  deleteKnowledgeById,
  getAllKnowledge,
} from '@/store/knowledge/actions'
import {
  isAllKnowledgeSuccess,
  isTopicsLoading,
} from '@/store/knowledge/selector'
import { getAllUserGroupOptions } from '@/store/notifications/actions'
import { getAllIntents as getAllIntentsSelector } from '@/store/questions/selector'
import { convertDataToMarkdownFormat } from '@/utils/appUtils'
import { TwoButtonModal as KnowledgeConfirmationModal } from '@/components/UI/Common'
import Loading from '@/components/UI/Loading/Loading'
import Pagination from '@/components/UI/Pagination/Pagination'
import PermissionWrapper from '@/components/UI/PermissionWrapper/PermissionWrapper'
import ProgressSteps from '@/components/UI/ProgressSteps/ProgressSteps'
import CustomMenu from '@/components/UI/CustomMenu'
import MoveSelectedModal from './MoveSelectedModal'
import ActionContextMenu from './ActionContextMenu'
import integrationService from '@/services/IntegrationService'
import { cn } from '@/lib/utils'
import LearningOutcomes from './LearningOutcomes'
import SharepointUrls from '@/components/UI/KnowledgeDatatableComponent/SharepointUrls'
import KGroupsTree from '@/components/UI/KGroupsTree'

function KnowledgeDatatableComponentGridView(props: any) {
  const { t } = useTranslation('translation')
  const commonState = useSelector(getCommonState)
  const isSuperadmin = useSelector(getIsSuperAdmin)
  const history: any = useHistory()
  const dispatch = useDispatch()
  const [selectedGroup, setSelectedGroup] = useState(null)
  const [perPage, setPerPage] = useState(30)
  const [currentPage, setCurrentPage] = useState(1)
  const allKnowledgeSuccess = useSelector(isAllKnowledgeSuccess)
  const topicsLoading = useSelector(isTopicsLoading)
  const allIntents = useSelector(getAllIntentsSelector)
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false)
  const [showDeletePermanentlyModal, setShowDeletePermanentlyModal] =
    useState(false)
  const [activeKey, setActiveKey] = useState(null)
  const [deletedRowId, setDeletedRowId] = useState([])
  const [showsSpSettings, setShowsSpSettings] = useState(false)

  const [loading, setLoading] = useState(false)
  const [selectedDoc, setSelectedDoc] = useState([])
  /**
   * Edit mode activate or de activate
   */
  const [editMode, setEditMode] = useState(false)
  const [selectedIntent, setSelectedIntent] = useState(null)

  // handle active tab
  const queryParams = new URLSearchParams(history.location.search)
  const defaultTab = history.location.state?.activeTab || 'viewDocument'
  const [activeTab, setActiveTab] = useState(
    queryParams.get('activeTab') || defaultTab,
  )

  useEffect(() => {
    if (!topicsLoading) {
      dispatch(getAllUserGroupOptions()) // user groups
    }
    setSelectedNodes([])
    setHasTopLevelApplied(false)

    if (isSuperadmin) {
      checkShowSpFolders()
    }
  }, [])

  useEffect(() => {
    if (
      selectedGroup?.group_type === 'system' &&
      (activeTab === 'viewLearningOutcomes' ||
        activeTab === 'viewSharePointSettings')
    ) {
      const nextTab = defaultTab || 'viewDocument'
      setActiveTab(nextTab)
      const params = new URLSearchParams(history.location.search)
      params.set('activeTab', nextTab)
      history.replace({
        pathname: history.location.pathname,
        search: params.toString(),
      })
    }
  }, [selectedGroup, activeTab])

  const checkShowSpFolders = async () => {
    const { status, data } = await integrationService.getIntegrations(
      'azure',
      'api',
    )
    if (status === 200) {
      // Check if data.data.integrations is available then loop through integrations
      if (data?.data?.integrations && data?.data?.integrations.length > 0) {
        setShowsSpSettings(true)
      }
    }
  }

  const editKnowledgehandler = (intent: any) => {
    const editModeCheck = !editMode
    setSelectedIntent(intent)
    setEditMode(editModeCheck)
  }

  const resetEditKnowledgehandler = (action: any) => {
    const editModeCheck = !editMode
    setSelectedIntent(null)
    setEditMode(editModeCheck)
    // From edit mode if any intent gets deleted then we have to reload data
    if (action === 'reload') {
      dispatch(
        getAllKnowledge(
          3,
          currentPage,
          perPage,
          query,
          '',
          {},
          selectedNodes.length > 0,
          props.documentId,
          commonState.selectedGroupId,
          hasTopLevelApplied,
        ),
      )
    }
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
    dispatch(
      getAllKnowledge(
        3,
        page,
        perPage,
        query,
        '',
        {},
        selectedNodes.length > 0,
        props.documentId,
        // commonState.selectedGroupId,
        selectedGroup?._id,
        // hasTopLevelApplied
        commonState.selectedGroupId ? false : true,
      ),
    )
  }
  /**
   * Used to paginate data based on per page and page number
   * @param newPerPage
   * @param page
   */
  const handlePerRowsChange = async (newPerPage: number, page: number) => {
    setPerPage(newPerPage)
    setCurrentPage(page)
    dispatch(
      getAllKnowledge(
        3,
        page,
        newPerPage,
        query,
        '',
        {},
        selectedNodes.length > 0,
        props.documentId,
        selectedGroup?._id,
        commonState.selectedGroupId ? false : true,
      ),
    )
  }

  /**
   * Set debounce time for while searching in any input
   */
  const [query, setQuery] = useState('')
  const [isTyping, setTyping] = useState(false)
  useEffect(() => {
    // Added 500 as debounce time will wait for 500 miliseconds and then we will fetch intents based on query
    const delayDebounceFn = setTimeout(() => {
      if (isTyping) {
        setCurrentPage(1)
        dispatch(
          getAllKnowledge(
            3,
            1,
            perPage,
            query,
            '',
            {},
            selectedNodes.length > 0,
            props.documentId,
            selectedGroup?._id,
            // query && query.length > 0 ? true : false
            commonState.selectedGroupId ? false : true,
          ),
        )
        setTyping(false)
      }
    }, 500)
    return () => clearTimeout(delayDebounceFn)
  }, [query])

  const onInputChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setQuery(e.target.value)
    setTyping(true)
  }
  /**
   * State to manage tags | categories as Nodes | Tags whatever we can say
   */
  const [selectedNodes, setSelectedNodes] = useState([])

  /**
   * Used to delete multiple knowledge based on IDS
   * @param e
   * @param selectedRowIds
   */
  const deleteConfirmed = async (
    selectedRowIds: string[],
    isArchiving: boolean = false,
  ) => {
    setLoading(true)
    await dispatch(deleteKnowledgeById(selectedRowIds, isArchiving))
    dispatch(
      getAllKnowledge(
        3,
        currentPage,
        perPage,
        query,
        '',
        {},
        selectedNodes.length > 0,
        props.documentId,
        selectedGroup?._id,
        hasTopLevelApplied,
      ),
    )
    setLoading(false)
    setSelectedNodes([])
  }

  /**
   * Used to sort data using API
   * @param param0
   * @param direction
   */
  const onSortHandler = (selector: any, direction: string) => {
    // For now we are allowing server side sorting on above two fields
    dispatch(
      getAllKnowledge(
        3,
        currentPage,
        perPage,
        query,
        '',
        {
          sort_field: selector === 'name' ? 'question' : selector,
          sort_order: direction === 'desc' ? 'dsc' : 'asc',
        },
        selectedNodes.length > 0,
        props.documentId,
        selectedGroup?._id,
        hasTopLevelApplied,
      ),
    )
  }

  /**
   * Used to sort data using API
   * @param param
   * @param direction
   */
  const [hasTopLevelApplied, setHasTopLevelApplied] = useState(true)

  useEffect(() => {
    if (activeTab !== 'viewKnowledge') return

    if (commonState.selectedYear || commonState.selectedGroupId) {
      // Handle selectedYear change
      const selectedId = !props.documentId
        ? commonState.selectedGroupId || commonState.selectedYear._id
        : null
      const options: any = { hasTopLevelApplied: hasTopLevelApplied }

      dispatch(
        getAllKnowledge(
          3,
          currentPage,
          perPage,
          query,
          '',
          {},
          selectedNodes.length > 0,
          props.documentId,
          selectedId,
          options,
        ),
      )
    }
  }, [commonState.selectedYear, commonState.selectedGroupId, activeTab])

  useEffect(() => {
    if (activeTab !== 'viewKnowledge') return
    if (commonState.selectedGroupId) {
      // Handle selectedGroupId change when selectedYear is not present
      const selectedId = !props.documentId ? commonState.selectedGroupId : null

      dispatch(
        getAllKnowledge(
          3,
          currentPage,
          perPage,
          query,
          '',
          {},
          selectedNodes.length > 0,
          props.documentId,
          selectedId,
        ),
      )
    }
  }, [commonState.selectedGroupId])

  // Show bulk assign category modal
  const [bulkAssignCategoryShow, setBulkAssignCategoryShow] = useState(false)
  const BulkAssignCategoryhandler = (value: boolean) => {
    setBulkAssignCategoryShow(value)
  }
  const bulkAssignCategoryKnowledgeHandler = () => {
    setBulkAssignCategoryShow(true)
  }

  const confirmCategoryUpdateHandler = async (selectedOption: any) => {
    try {
      BulkAssignCategoryhandler(false)
      await dispatch(bulkAssignModules(selectedOption, selectedNodes))
      setSelectedNodes([])
    } catch (error: any) {
      setSelectedNodes([])
    }
  }

  const addToSelectedRows = (event: any, id: string) => {
    let data: any[] = [...selectedNodes]
    if (event.target.checked) {
      const isPresent = data.indexOf(id)
      if (isPresent < 0) {
        data.push(id)
      }
    } else {
      const oldData = [...selectedNodes]
      const index = oldData.indexOf(id)
      oldData.splice(index, 1)
      data = [...oldData]
    }
    setSelectedNodes([..._.uniq(data)])
  }

  const onSelectAllRows = (event: any) => {
    if (event.target.checked) {
      if (
        allKnowledgeSuccess &&
        allKnowledgeSuccess.intents &&
        allKnowledgeSuccess.intents.length > 0
      ) {
        let data: any[] = [
          ...allKnowledgeSuccess.intents.map((intent: any) => intent._id),
        ]
        setSelectedNodes([..._.uniq(data)])
      }
    } else {
      setSelectedNodes([])
    }
  }

  const ContextAwareToggle = ({ children, eventKey, breadcrumbs }: any) => {
    const currentEventKey = useContext(AccordionContext)
    setActiveKey(currentEventKey)
    const decoratedOnClick = useAccordionToggle(eventKey, () => {})
    const isCurrentEventKeyActive = currentEventKey === eventKey

    return (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        className="tw-px-4"
        onClick={decoratedOnClick}
      >
        <Stack direction="row" alignItems="center" gap={2}>
          <input
            type="checkbox"
            className="mr-2"
            onChange={e => {
              addToSelectedRows(e, eventKey)
            }}
            checked={selectedNodes.indexOf(eventKey) >= 0}
          />
          <Stack sx={{ py: '12px' }}>
            <Typography
              component="p"
              sx={{ fontSize: '14px', fontWeight: 600 }}
            >
              {children}
            </Typography>
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 400,
                color: '#5F5E5E',
              }}
            >
              {breadcrumbs.map((b: any) => b.name).join('/')}
            </Typography>
          </Stack>
        </Stack>
        <IconButton size="small">
          <ChevronRightIcon
            color="primary"
            className={cn({ 'tw-rotate-90': isCurrentEventKeyActive })}
          />
        </IconButton>
      </Stack>
    )
  }

  const knowledgeHtml = (
    <>
      <div className="all-knowledge-search mb-2 tw-flex tw-flex-wrap tw-items-center tw-gap-2">
        <CustomMenu
          textTrigger={t('Sort')}
          options={[
            {
              label: t('Most Recent'),
              onClick: () => onSortHandler('updated_at', 'desc'),
            },
            {
              label: t('Ascending'),
              onClick: () => onSortHandler('name', 'asc'),
            },
            {
              label: t('Descending'),
              onClick: () => onSortHandler('name', 'desc'),
            },
          ]}
          slotProps={{
            trigger: {
              startIcon: <FilterListIcon fontSize="small" />,
              size: 'small',
              variant: 'outlined',
              sx: { padding: '8px 12px', fontWeight: 700 },
            },
          }}
        />
        <div className="web-links my-0 mr-0">
          <input
            type="text"
            className="form-control"
            placeholder={t('Search for Questions')}
            onChange={onInputChangeHandler}
          />
        </div>
        <ActionContextMenu
          triggerText={t('+ Add')}
          menuItems={[
            {
              text: t('Create from Scratch'),
              action: () =>
                history.push(
                  KNOWLEDGE_KNOWLEDGE_CREATE_FROM_SCRATCH +
                    (!hasTopLevelApplied
                      ? `?group=${selectedGroup?._id}&parent=${commonState.selectedYear._id}&view-all=true`
                      : ''),
                ),
            },
            {
              text: t('Create from Document'),
              action: () =>
                history.push(
                  TOOLKIT_GENERATE_QNA_UPLOAD_DOC +
                    `?group=${selectedGroup?._id}`,
                ),
            },
          ]}
        />
      </div>
      <div className="d-flex flex-wrap justify-content-between align-items-center mt-1">
        <div className="d-flex align-items-center">
          {allKnowledgeSuccess?.intents?.length > 0 && (
            <div className="custom-checkbox mr-3">
              <input
                type="checkbox"
                className="mr-2"
                id="select-all"
                checked={
                  allKnowledgeSuccess &&
                  allKnowledgeSuccess.intents &&
                  allKnowledgeSuccess.intents.length > 0 &&
                  selectedNodes.length === allKnowledgeSuccess.intents.length
                }
                onChange={onSelectAllRows}
              />
              <label htmlFor="select-all" className="mb-0">
                {t('Select all')}
              </label>
            </div>
          )}
          {selectedNodes && selectedNodes.length > 0 && (
            <PermissionWrapper>
              <button
                className="btn btn-suggest py-0 font-sm"
                onClick={e => bulkAssignCategoryKnowledgeHandler()}
              >
                {t('Move Selected')}
              </button>
              <button
                className="btn btn-outline-danger border-0 py-0 font-600 font-sm"
                onClick={() => {
                  setDeletedRowId(selectedNodes)
                  setShowDeleteConfirmationModal(true)
                }}
              >
                {t('Delete Selected')}
              </button>
            </PermissionWrapper>
          )}
        </div>
      </div>
      <Accordion
        defaultActiveKey={
          allKnowledgeSuccess && allKnowledgeSuccess.intents.length > 0
            ? allKnowledgeSuccess.intents[0]._id
            : null
        }
        className="accordion-viewby mt-3 "
      >
        {allKnowledgeSuccess?.intents?.map((knowledge: any, index: number) => {
          const parent = allIntents.find(
            (intent: any) => intent._id === knowledge.parent_id,
          )
          return (
            <Card
              className={activeKey === '0' ? 'active' : 'notactive'}
              key={knowledge?._id}
            >
              <ContextAwareToggle
                eventKey={knowledge?._id}
                breadcrumbs={
                  knowledge.breadcrumbs && knowledge.breadcrumbs.length > 0
                    ? knowledge.breadcrumbs
                    : []
                }
              >
                {knowledge.questions && knowledge.questions.length > 0
                  ? knowledge.questions[knowledge.questions.length - 1].text
                  : ''}
              </ContextAwareToggle>
              <Accordion.Collapse eventKey={knowledge?._id}>
                <Card.Body>
                  <div>
                    <h3 className="h6 clr-black mb-1">{t('Answer:')}</h3>
                    {knowledge.responses && knowledge.responses.length > 0 ? (
                      <ReactMarkdown>
                        {knowledge.responses[0].text}
                      </ReactMarkdown>
                    ) : (
                      ''
                    )}
                  </div>
                  <Row className="mt-3">
                    <Col md={4} className="my-2 my-md-0">
                      <h3 className="h6 clr-black mb-1">
                        {t('Generated from:')}
                      </h3>
                      <div>{knowledge?.document_name}</div>
                    </Col>
                    <Col md={3} className="my-2 my-md-0">
                      <h3 className="h6 clr-black mb-1">{t('Created by')}</h3>
                      <div>{knowledge?.author_email}</div>
                    </Col>
                    <Col md={5} className="my-2 my-md-0">
                      <h3 className="h6 clr-black mb-1">{t('Last Updated')}</h3>
                      <div>
                        {dayjs
                          .utc(knowledge.updated_at)
                          .local()
                          .format('DD/MM/YYYY hh:mm A')}
                      </div>
                    </Col>
                  </Row>
                  <div className="mt-3 d-none">
                    <h3 className="h6 clr-black mb-1">
                      {t('Possible questions')}
                    </h3>
                    <ol>
                      {knowledge.questions.length > 0
                        ? knowledge.questions.map(
                            (q: { text: string }, i: number) => {
                              return (
                                <li key={'q_' + knowledge._id + '_' + i}>
                                  <p>{q.text}</p>
                                </li>
                              )
                            },
                          )
                        : '-'}
                    </ol>
                  </div>
                  <div className="mt-3 d-none">
                    <h3 className="h6 clr-black mb-1">
                      {t('Possible responses')}
                    </h3>
                    <ol>
                      {knowledge.responses.length > 0
                        ? knowledge.responses.map(
                            (
                              response: {
                                text: string
                                group_ids: any
                              },
                              i: number,
                            ) => {
                              return (
                                <li key={'response_' + knowledge._id + '_' + i}>
                                  <p>
                                    {convertDataToMarkdownFormat(response.text)}
                                  </p>
                                </li>
                              )
                            },
                          )
                        : '-'}
                    </ol>
                  </div>
                  <div className="mt-3 d-none">
                    <h3 className="h6 clr-black mb-1">
                      {t('Parent question')}
                    </h3>

                    {parent ? parent.name : '-'}
                  </div>
                  <div className="tw-flex tw-justify-end tw-gap-3 tw-mt-3">
                    <Button
                      variant="outlined"
                      onClick={() => editKnowledgehandler(knowledge)}
                    >
                      {t('Edit')}
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => {
                        setDeletedRowId([knowledge._id])
                        setShowDeleteConfirmationModal(true)
                      }}
                    >
                      {t('Delete')}
                    </Button>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          )
        })}
      </Accordion>

      {/* empty state */}
      {allKnowledgeSuccess && allKnowledgeSuccess.intents.length === 0 && (
        <div className="empty-knowledge text-center my-2">
          <h3 className="h6 clr-grey-txt7 mb-3">
            {t('You have yet to create knowledge')}
          </h3>
          <figure className="h-auto">
            <img src={emptyKnowledge} alt="" />
          </figure>
          <div className="clr-primary font-weight-bold">
            {/* Drop a document here <span className="clr-grey-txt7">or</span>{" "} <br /> */}
            <Link
              to={
                KNOWLEDGE_KNOWLEDGE_CREATE_FROM_SCRATCH +
                (!hasTopLevelApplied
                  ? `?group=${commonState.selectedGroupId}&parent=${
                      commonState.selectedYear
                        ? commonState.selectedYear._id
                        : ''
                    }`
                  : '')
              }
            >
              {t('Click here to get started')}
            </Link>
          </div>
        </div>
      )}

      {allKnowledgeSuccess &&
        allKnowledgeSuccess.pagination &&
        allKnowledgeSuccess.intents.length > 0 && (
          <Pagination
            currentPage={currentPage}
            pagination={allKnowledgeSuccess.pagination}
            paginationPerPage={perPage}
            pageChange={handlePerRowsChange}
            onChangePage={handlePageChange}
            style={{ position: 'relative' }}
          />
        )}
    </>
  )

  if (loading) {
    return <Loading />
  }

  return (
    <>
      <KnowledgeConfirmationModal
        show={showDeletePermanentlyModal}
        title={t('Confirm Delete')}
        message={
          t('Are you sure you want to delete? Deleted Items will be ') +
          '<b class="clr-red">' +
          t('deleted permanently.') +
          '</b>'
        }
        innerHtml
        size={'lg'}
        leftButtonText={t('Delete')}
        leftButtonClassName="btn btn-outline-danger font-weight-normal mx-2"
        rightButtonText={t('Cancel')}
        rightButtonClassName="btn btn-outline-primary font-weight-normal mx-2"
        onClickLeftButton={() => {
          setShowDeletePermanentlyModal(false)
          deleteConfirmed(deletedRowId)
        }}
        onClickRightButton={() => {
          setShowDeletePermanentlyModal(false)
        }}
        onClickClose={() => setShowDeletePermanentlyModal(false)}
      />
      <KnowledgeConfirmationModal
        show={showDeleteConfirmationModal}
        title={t('Remove Knowledge')}
        message={t(
          'Would you like to archive or delete the knowledge(s) from Knowledge base?',
        )}
        size={'lg'}
        leftButtonText={t('Delete')}
        leftButtonClassName="btn btn-outline-danger font-weight-normal mx-2"
        rightButtonText={t('Archive')}
        rightButtonClassName="btn btn-primary font-weight-normal mx-2"
        onClickLeftButton={() => {
          setShowDeleteConfirmationModal(false)
          setShowDeletePermanentlyModal(true)
        }}
        onClickRightButton={() => {
          setShowDeleteConfirmationModal(false)
          deleteConfirmed(deletedRowId, true)
        }}
        onClickClose={() => setShowDeleteConfirmationModal(false)}
      />

      <MoveSelectedModal
        show={bulkAssignCategoryShow}
        onHide={() => BulkAssignCategoryhandler(false)}
        confirmCategoryUpdate={confirmCategoryUpdateHandler}
      />

      <div>
        {props.createFromUploadedDocument && (
          <div className="levels-row mb-4 d-flex">
            <div className="ml-auto text-nowrap">
              {' '}
              <button
                className="btn btn-primary font-400 font-16 p-1 px-3"
                onClick={() => {
                  const queTypes =
                    props.queTypes && props.queTypes.length > 0
                      ? `&queTypes=${props.queTypes.join(',')}`
                      : ''
                  const quizId =
                    props.isEditQuiz && props.quizId
                      ? `&quizId=${props.quizId}`
                      : ''
                  let docs =
                    props.document_Id && props.document_Id.length > 0
                      ? [...props.document_Id]
                      : []
                  if (docs && docs.length > 0) {
                    docs.unshift(selectedDoc[0])
                  }
                  const documents =
                    docs && docs.length > 0 ? [...docs] : selectedDoc
                  history.push(
                    REVIEW_QUIZ_QUESTIONS +
                      `?document=${documents.join(
                        ',',
                      )}${quizId}${queTypes}&reference=add-new`,
                    {
                      createFromUploadedDocument:
                        props.isEditQuiz && props.quizId
                          ? !props.createFromUploadedDocument
                          : props.createFromUploadedDocument,
                      queryString: props.selectedGroupIdForDocument
                        ? '?group=' + props.selectedGroupIdForDocument
                        : `?group=${commonState.selectedGroupId}&parent=${
                            commonState.selectedYear
                              ? commonState.selectedYear._id
                              : ''
                          }`,
                      isEditQuiz: props.isEditQuiz,
                      quizId: props.quizId,
                      questionBank: props.questionBank,
                    },
                  )
                }}
                disabled={selectedDoc?.length === 0}
              >
                {t('View Generated Knowledge')}
              </button>
            </div>
          </div>
        )}

        <div className="tw-flex">
          <KGroupsTree
            syncsState={true}
            actions={{ add: true, edit: true, delete: true }}
            archivedRoute={KNOWLEDGE_ARCHIVED}
            showsManageGroups={true}
            slotProps={{ root: { className: 'tw-w-2/12' } }}
            onSelectGroup={group => {
              setSelectedGroup(group)
            }}
          />
          <div className="tw-w-10/12 tw-pl-0">
            <Box
              className="tw-px-4 tw-py-2"
              sx={{ '& nav': { display: 'inline-flex' } }}
            >
              {!props.buildKnowledge && (
                <h2 className="mb-0 mr-3 font-1 d-md-inline-block">
                  {t('View:')}{' '}
                </h2>
              )}
              <Tabs
                activeKey={
                  props.createFromUploadedDocument ? 'viewDocument' : activeTab
                }
                onSelect={(e: string | null) => {
                  if (!e) return
                  setActiveTab(e)
                  const params = new URLSearchParams(history.location.search)
                  params.set('activeTab', e)
                  history.replace({
                    pathname: history.location.pathname,
                    search: params.toString(),
                  })
                }}
              >
                <Tab eventKey="viewDocument" title={t('Documents')}>
                  {activeTab === 'viewDocument' && (
                    <UploadedDocuments
                      isArchived={false}
                      queryString={
                        props.selectedGroupIdForDocument
                          ? '?group=' + props.selectedGroupIdForDocument
                          : `?group=${selectedGroup?._id}&parent=${
                              commonState.selectedYear
                                ? commonState.selectedYear._id
                                : ''
                            }`
                      }
                      selectedGroupId={selectedGroup?._id}
                      createFromUploadedDocument={
                        props.createFromUploadedDocument
                      }
                      isContexualised={false}
                      isEditQuiz={props.isEditQuiz}
                      quizId={props.quizId}
                      buildV2={props.buildV2}
                      buildKnowledge={props.buildKnowledge}
                      toolkitQuestionTypes={props.toolkitQuestionTypes}
                      toolkitQuizId={props.toolkitQuizId}
                      toolkitSelectedGroupId={props.toolkitSelectedGroupId}
                      showAllDocuments={props.showAllDocuments}
                      setSelectedDoc={setSelectedDoc}
                      addMoreQuestionFromDocument={
                        props.addMoreQuestionFromDocument
                      }
                      flowKey={props.flowKey}
                      popupProperties={props.popupProperties}
                    />
                  )}
                </Tab>

                {!props.createFromUploadedDocument && !props.buildKnowledge && (
                  <Tab eventKey="viewKnowledge" title={t('Flash Cards')}>
                    {activeTab === 'viewKnowledge' && knowledgeHtml}
                  </Tab>
                )}

                {selectedGroup?.group_type !== 'system' &&
                  !props.createFromUploadedDocument &&
                  !props.buildKnowledge && (
                    <Tab
                      eventKey="viewLearningOutcomes"
                      title={t('Learning Outcomes')}
                    >
                      {activeTab === 'viewLearningOutcomes' && (
                        <LearningOutcomes groupId={selectedGroup?._id} />
                      )}
                    </Tab>
                  )}

                {selectedGroup?.group_type !== 'system' &&
                  showsSpSettings &&
                  !props.createFromUploadedDocument &&
                  !props.buildKnowledge && (
                    <Tab
                      eventKey="viewSharePointSettings"
                      title={t('SharePoint URLs')}
                    >
                      {activeTab === 'viewSharePointSettings' && (
                        <SharepointUrls groupId={selectedGroup?._id} />
                      )}
                    </Tab>
                  )}
              </Tabs>
            </Box>
          </div>
          {editMode && (
            <div className="edit-knowledge-sidewrap">
              <KnowledgeCreateFromScratch
                resetEditKnowledgehandler={resetEditKnowledgehandler}
                selectedIntent={selectedIntent}
                editMode={editMode}
                viewall
              />
            </div>
          )}
        </div>
      </div>
      {props.buildKnowledge && (
        <ProgressSteps
          currentStep={1}
          steps={props.summariseDocument ? 3 : 4}
        />
      )}
    </>
  )
}

export default KnowledgeDatatableComponentGridView
